// we might leverage trackingData.partner, trackingData.referrer in the future
const channelTracking = require('@vp/channel-tracking');

function getAttribute() {
    let trackingData = channelTracking.getTrackingData();
    if (!trackingData || trackingData.timestamp === undefined) {
        channelTracking.initChannelTracking();
        trackingData = channelTracking.getTrackingData();
    }

    if (trackingData && trackingData.utm_id) {
        return trackingData.utm_id;
    }

    return undefined;
}
module.exports = { getAttribute };
